<template>
  <div>
    <div class="row align-items-end">
      <div class="col-auto flex-grow-1">
        <div class="form-group">
          <label for="select_1_1">Поиск</label>
          <div class="input-affix">
            <i class="prefix-icon anticon anticon-search"></i>
            <input
              type="text"
              class="form-control"
              v-model="searchText"
              placeholder="Поиск"
            />
          </div>
        </div>
      </div>

      <div class="col-auto">
        <button
          class="btn btn-primary mb-4 ml-auto d-block"
          style="white-space: nowrap"
          @click="addModalShow"
        >
          Добавить
        </button>
      </div>
    </div>
    <hr class="mt-0 mb-2" />
    <template v-if="newSearchList.length">
      <div class="row align-items-center" v-if="newSearchList.length">
        <div class="col-auto mr-auto mb-2">
          <PerPageLenth
            class="mr-3"
            :page="page"
            :perPage="perPage"
            :allDataLenth="newSearchList.length"
          />
          <PerPageCount :perPage="perPage" @perPageSet="perPageSet" />
        </div>
        <div class="col-auto mb-2">
          <button
            class="btn btn-sm btn-icon btn-secondary btn-tone excel"
            @click="downloadFile"
          >
            <i class="anticon anticon-file-excel"></i>
          </button>
        </div>
      </div>
      <hr class="mt-0 mb-2" />
    </template>
    <template v-if="newSearchList.length">
      <table
        class="table table-sm table-responsive-md table-striped table-hover"
      >
        <thead class="">
          <tr>
            <th scope="col">#</th>
            <th scope="col">---</th>
            <th scope="col">Кыргызча</th>
            <th scope="col">Русский</th>
            <th scope="col">English</th>
            <th scope="col" class="text-center" style="white-space: nowrap">
              Ин/о
            </th>
            <th scope="col" class="text-center" style="white-space: nowrap">
              Ин/з
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in newDatalist" :key="item.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ item.short_name }}</td>
            <td>{{ item.name_kg }}</td>
            <td>{{ item.name_ru }}</td>
            <td>{{ item.name_en }}</td>
            <td class="text-center">{{ item.id_integration_oo }}</td>
            <td class="text-center">{{ item.id_integration_zo }}</td>

            <td class="text-right">
              <!-- <button class="btn btn-primary btn-xs mr-1">btn-xs</button> -->
              <button
                class="btn btn-icon btn-sm btn-success btn-tone mr-1 mb-1 mb-lg-0"
                @click="editModalShow(item)"
              >
                <i class="anticon anticon-edit"></i>
              </button>
              <button
                class="btn btn-icon btn-sm btn-danger btn-tone"
                @click="deleteModalShow(item)"
              >
                <i class="anticon anticon-delete"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </template>
    <div v-else class="noTdData">Нет данных</div>
    <Pagination
      :total="newSearchList.length"
      :perPage="perPage"
      @activePage="currentPage"
    />
    <Modal :isShow="isAddModalShow" @closeModal="addModalClose">
      <template v-slot:title> Добавить факультет </template>
      <template>
        <div class="form-group">
          <label for="kg_l">Короткий имя</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="fak.val.short_name"
            required
          />
        </div>
        <div class="form-group">
          <label for="kg_l">Кыргызча</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="fak.val.name_kg"
            required
          />
        </div>
        <div class="form-group">
          <label for="ru_l">Русский</label>
          <input
            type="text"
            class="form-control"
            id="ru_l"
            v-model="fak.val.name_ru"
            required
          />
        </div>
        <div class="form-group">
          <label for="en_l">English</label>
          <input
            type="text"
            class="form-control"
            id="en_l"
            v-model="fak.val.name_en"
            required
          />
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="in_1">№ Интеграции очный</label>
              <input
                type="text"
                class="form-control"
                id="in_1"
                v-model="fak.val.id_integration_oo"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="in_2">№ Интеграции заочный</label>
              <input
                type="text"
                class="form-control"
                id="in_2"
                v-model="fak.val.id_integration_zo"
                required
              />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="addModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="addPost">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isEditModalShow" @closeModal="editModalClose">
      <template v-slot:title> Изменить факультет </template>
      <template v-if="fak.items != null">
        <div class="form-group">
          <label for="kg_l">Короткий имя</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="fak.val.short_name"
            required
          />
        </div>
        <div class="form-group">
          <label for="kg_l">Кыргызча</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="fak.val.name_kg"
            required
          />
        </div>
        <div class="form-group">
          <label for="ru_l">Русский</label>
          <input
            type="text"
            class="form-control"
            id="ru_l"
            v-model="fak.val.name_ru"
            required
          />
        </div>
        <div class="form-group">
          <label for="en_l">English</label>
          <input
            type="text"
            class="form-control"
            id="en_l"
            v-model="fak.val.name_en"
            required
          />
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="in_l">№ Интеграции очный</label>
              <input
                type="text"
                class="form-control"
                id="in_l"
                v-model="fak.val.id_integration_oo"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="en_l">№ Интеграции заочный</label>
              <input
                type="text"
                class="form-control"
                id="en_l"
                v-model="fak.val.id_integration_zo"
                required
              />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="editModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="editFak">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isDeleteModalShow" @closeModal="deleteModalClose">
      <template v-slot:title> Удалить факультет </template>

      <template>
        <h5>Вы действительно хотите удалить?</h5>
        <template v-if="newDatalist.length">
          <p>{{ fak.val.name_kg }}</p>
        </template>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="deleteModalClose"
        >
          Отмена
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click.prevent="deleteFak"
        >
          Подтвердить
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import xlsx from "json-as-xlsx";

import Pagination from "@/components/others/Pagination.vue";
import PerPageLenth from "@/components/others/PerPageLenth.vue";
import PerPageCount from "@/components/others/PerPageCount.vue";
import Modal from "@/components/others/Modal.vue";

export default {
  name: "Faculty",
  components: {
    Pagination,
    PerPageLenth,
    PerPageCount,
    Modal,
  },
  data() {
    return {
      exelIcon: require("@/assets/images/others/excel.png"),
      isAddModalShow: false,
      isEditModalShow: false,
      isDeleteModalShow: false,
      fak: { id: null, items: [], val: {} },
      page: 1,
      perPage: 10,
      searchText: "",
    };
  },
  computed: {
    newSearchList() {
      const regEx = new RegExp(this.searchText, "i");
      return this.fak.items.filter((x) => x.name_kg.match(regEx));
    },
    newDatalist() {
      return this.newSearchList.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  methods: {
    currentPage(i) {
      this.page = i;
    },
    perPageSet(count) {
      this.perPage = count;
    },
    downloadFile() {
      let data = [
        {
          sheet: "Факультет",
          columns: [
            { label: "id", value: "id" },
            { label: "---", value: "short_name" },
            { label: "Кыргызча", value: "name_kg" },
            { label: "Русский", value: "name_ru" },
            { label: "English", value: "name_en" },
            { label: "Интеграция очный", value: "id_integration_oo" },
            { label: "Интеграция заочный", value: "id_integration_zo" },
          ],
          content: [...this.newSearchList],
        },
      ];
      let settings = {
        fileName: "Факультет",
      };
      xlsx(data, settings);
    },
    addModalShow() {
      this.fak.val = {};
      this.isAddModalShow = true;
    },
    addModalClose() {
      this.isAddModalShow = false;
    },
    editModalShow(item) {
      this.fak.val = { ...item };
      this.isEditModalShow = true;
    },
    editModalClose() {
      this.isEditModalShow = false;
    },
    deleteModalShow(item) {
      this.fak.val = { ...item};
      this.isDeleteModalShow = true;     

      // this.dindex = this.fak.items.map(t=>t.id).indexOf(index)
    },
    deleteModalClose() {
      this.isDeleteModalShow = false;
    },
    async getFak() {
      try {
        const data = (await this.$api.plan.plan_faculty()).data;
        this.fak.items = data;
        // console.log(data);
      } catch (error) {
        console.log(error.message);
      }
    },
    async add_faculty() {
      try {
        await this.$api.facultySpec.add_faculty(this.fak.val);
        this.$nt("Успешно сохранен", "success");
        this.fak.val = {};
        this.addModalClose();
        this.getFak();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка сохранения", "dagner");
      }
    },
    async update_faculty() {
      try {
        await this.$api.facultySpec.update_faculty(this.fak.val);
        this.$nt("Успешно изменен", "success");
        this.fak.val = {};
        this.editModalClose();
        this.getFak();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка изменения", "dagner");
      }
    },
    async delete_faculty() {
      try {
        await this.$api.facultySpec.delete_faculty({ id: this.fak.val.id });
        this.$nt("Успешно удален", "success");
        this.fak.val = {};
        this.deleteModalClose();
        this.getFak();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка удаления", "dagner");
      }
    },
    addPost() {
      this.add_faculty();      
    },
    editFak() {
      this.update_faculty();      
    },
    deleteFak() {
      this.delete_faculty();      
    },
  },

  mounted() {
    this.$nextTick(function () {
      this.getFak();
    });
  },
};
</script>
<style lang="scss" scoped>
td:last-child {
  word-wrap: none;
}
</style>
